import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-neutral-900 mb-4">404</h1>
        <p className="text-xl text-neutral-600 mb-8">Page non trouvee</p>
        <Link to="/" className="text-primary-600 hover:text-primary-700 underline">
          Retour a l&apos;accueil
        </Link>
      </div>
    </div>
  );
}
